import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';
import { AlertComponent, ConfirmationComponent } from '@angular/synthrone-design/components';
import { AddUpdateFontFormComponent } from '@synthroneApp/components/forms/add-update-font-form/add-update-font-form.component';
import { OrganizationFontVariantsViewComponent } from '@synthroneApp/components/views/organization-font-variants-view/organization-font-variants-view.component';

@Component({
  selector: 'app-organization-fonts-view',
  templateUrl: './organization-fonts-view.component.html',
  styleUrls: ['./organization-fonts-view.component.scss']
})
export class OrganizationFontsViewComponent implements OnInit {

@ViewChild('fontsTable') fontsTable;
  
  configColumns = {
    family: {
      label: 'Name',
      sortable: false,
      truncate: true
    }
  };

  organizationPlanet: String;
  OrganizationFontVariantsViewComponent: any = OrganizationFontVariantsViewComponent;

  constructor(
    private _router: Router, 
    private route: ActivatedRoute, 
    protected api: ApiService, 
    @Inject(APP_CONFIG) private config, 
    protected dialog: MatDialog
  ) { }

  ngOnInit() {
    this.organizationPlanet = this.route.snapshot.params['planet'];
  }

  refreshTable = () => {
      this.fontsTable.getData()
  };

  deleteRow = (row) => {
    let dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        message: `Are you sure you want to remove the <b>${row.family}</b> font family? <br>Removal is irreversible.`
      }
    }).afterClosed().subscribe((response) => {
      if (response == "proceed") {
        const params: any = {
            id: row.id,
        };
        this.api.makeRequest('api_system_fonts_delete', params, 'crafter').subscribe(() => {
          this.refreshTable();
        });
      }
    });
  };

  editRow = (row) => {
    this.dialog.open(AddUpdateFontFormComponent, {
        height: '285px',
        width: '800px',
        data: {
            dataId: row.id,
            oldName: row.family,
            callback: (newName: string) => {
                const params: any = {
                    id: row.id,
                    jsonPayload: {
                      family: newName
                    }
                };
                return this.api.makeRequest('api_system_fonts_update', params, 'crafter');
            }
        },
        panelClass: 'no-padding-container'
    }).afterClosed().subscribe((response) => {
        if (response === true) {
            this.refreshTable();
        }
    });
  }

  sdClient = (limit, offset, sortBy, sortOrder): Observable<any> => {
      return this.api.makeRequest('api_system_fonts_list', {
          client: this.organizationPlanet
      }, 'crafter');
  }

  addFontFamily = () => {
    this.dialog.open(AddUpdateFontFormComponent, {
        height: '285px',
        width: '800px',
        data: {
            oldName: '',
            callback: (newName: string) => {
                const params: any = {
                  client: this.organizationPlanet,
                  family: newName
                };
                return this.api.makeRequest('api_system_fonts_create', params, 'crafter');
            }
        },
        panelClass: 'no-padding-container'
    }).afterClosed().subscribe((response) => {
        if (response === true) {
            this.refreshTable();
        }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/organization-fonts-view/organization-fonts-view.component.ts